// extracted by mini-css-extract-plugin
export default {"canvasWrapper":"EditableImageCanvas_canvasWrapper__oScGy","controls":"EditableImageCanvas_controls__bwoxC"};